import apiClient from './client';

export const authApi = {
  async login(email, password) {
    const response = await apiClient.post('/auth/login', { email, password });
    if (response.token) {
      apiClient.setToken(response.token);
    }
    return response;
  },

  logout() {
    apiClient.setToken(null);
  },

  getMe() {
    return apiClient.get('/auth/me');
  },

  changePassword(currentPassword, newPassword) {
    return apiClient.put('/auth/password', { currentPassword, newPassword });
  },

  isAuthenticated() {
    return !!apiClient.getToken();
  },
};

export default authApi;
